import { Tooltip, TooltipProps } from '@mui/material';
import { FC, useMemo, ReactNode } from 'react';
import cn from 'classnames';
import colors from '@styles/colors.module.scss';

import styles from './style.module.scss';

interface Props {
  title: ReactNode;
  variant?: 'normal' | 'error';
}

const Arrow: FC<Pick<Props, 'variant'>> = ({ variant = 'normal' }) => (
  <span className={cn(styles.arrow, variant === 'error' && styles.arrowError)} />
);

export const Hint: FC<Props & TooltipProps> = ({ title, children, arrow = true, variant = 'normal', ...rest }) => {
  const slotProps = useMemo(() => {
    if (variant === 'error') {
      return {
        arrow: { variant } as any,
        tooltip: {
          sx: {
            bgcolor: colors.error,
            color: colors.white,
          },
        },
      };
    }
    return undefined;
  }, [variant]);

  return (
    <Tooltip
      title={title}
      arrow={arrow}
      slots={{ arrow: Arrow }}
      slotProps={slotProps}
      placement="bottom-start"
      {...rest}>
      {children}
    </Tooltip>
  );
};
